document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const html = document.documentElement;

  // --- LOADER FAIL-SAFE ---
  // If anything halts the script, this ensures the site becomes accessible after 6s
  const failSafeTimeout = setTimeout(() => {
    const loader = document.getElementById('site-loader');
    if (loader && !document.body.classList.contains('loader-done')) {
      console.warn('Loader Fail-safe triggered.');
      loader.style.display = 'none';
      document.body.classList.remove('loader-active');
      document.body.classList.add('loader-done', 'loader-hidden');
    }
  }, 6000);

  // --- iOS Fullscreen & Toolbar Hiding Helper ---
  const handleIOSFullscreen = () => {
    // 1. Fix for 100vh on mobile browsers using custom variable
    let prevWidth = window.innerWidth;
    const setViewportHeight = () => {
      if (!document.documentElement.style.getPropertyValue('--vh') || window.innerWidth !== prevWidth) {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        prevWidth = window.innerWidth;
      }
    };
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);
    setViewportHeight();

    // 2. Hide address bar on load (Legacy trick, still works on some versions)
    window.addEventListener("load", function() {
      if (window.pageYOffset === 0) {
        setTimeout(function() {
          window.scrollTo(0, 1);
        }, 100);
      }
    });
  };
  handleIOSFullscreen();

  const header = document.getElementById('main-header');
  let sections = document.querySelectorAll('.snap-section');
  const menuToggle = document.getElementById('menu-toggle');
  const menuDrawer = document.getElementById('menu-drawer');
  const menuStages = document.getElementById('menu-stages');
  const mainView = document.getElementById('collection-main-view');
  
  // --- Desktop Dropdown Logic ---
  const desktopNavItems = document.querySelectorAll('.desktop-nav-item.has-dropdown');
  const desktopDropdownTriggers = document.querySelectorAll('.desktop-dropdown-trigger');

  const updateHeaderExpansion = () => {
    const isAnyOpen = document.querySelector('.desktop-nav-item.force-open') || 
                      Array.from(desktopNavItems).some(item => item.matches(':hover'));
    if (isAnyOpen && window.innerWidth > 1024) {
      header.classList.add('nav-expanded');
    } else {
      header.classList.remove('nav-expanded');
    }
  };

  desktopNavItems.forEach(item => {
    item.addEventListener('mouseenter', updateHeaderExpansion);
    item.addEventListener('mouseleave', () => {
      // Small delay to check if we moved to another item or if one is forced open
      setTimeout(updateHeaderExpansion, 200);
    });
  });

  desktopDropdownTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const parentItem = trigger.closest('.desktop-nav-item');
      if (parentItem) {
        const isActive = parentItem.classList.contains('force-open');
        document.querySelectorAll('.desktop-nav-item.force-open').forEach(el => {
          el.classList.remove('force-open');
        });

        if (!isActive) {
          parentItem.classList.add('force-open');
        }
        updateHeaderExpansion();
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.desktop-nav-item.has-dropdown')) {
      document.querySelectorAll('.desktop-nav-item.force-open').forEach(el => {
        el.classList.remove('force-open');
      });
      updateHeaderExpansion();
    }
  });
  
  let isLoaderDone = false;
  let scrollY = window.scrollY;
  let vh = window.innerHeight;

  // --- Cart State Management ---
  let itemsInCart = [];
  const cartCounter = document.querySelector('.cart-count');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartItemsContainer = document.getElementById('cart-drawer-items');
  const cartFooter = document.getElementById('cart-drawer-footer');
  const cartTotalPrice = document.getElementById('cart-total-price');

  const refreshCartState = () => {
    const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(rootUrl + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        itemsInCart = cart.items.map(item => item.variant_id.toString());
        
        if(cartCounter) {
          cartCounter.textContent = cart.item_count;
          cartCounter.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }

        // Render Cart Drawer Items
        if (cartItemsContainer) {
          if (cart.item_count === 0) {
            cartItemsContainer.innerHTML = '<div class="cart-empty-message">Your cart is currently empty.</div>';
            if (cartFooter) cartFooter.style.display = 'none';
          } else {
            let itemsHtml = '';
            cart.items.forEach(item => {
              const priceFormatted = (window.Shopify && window.Shopify.formatMoney) ? Shopify.formatMoney(item.line_price) : `Rs. ${(item.line_price/100).toLocaleString()}`;
              
              // Construct variant options string (e.g., "Fall and Edging: Yes")
              let optionsString = '';
              
              if (item.options_with_values && item.options_with_values.length > 0) {
                optionsString = item.options_with_values.map(o => `${o.name}: ${o.value}`).join(' / ');
              } else if (item.variant_title && item.variant_title !== 'Default Title') {
                optionsString = item.variant_title;
              }
              
              itemsHtml += `
                <div class="cart-item" data-variant-id="${item.variant_id}">
                  <div class="cart-item-image">
                    <img src="${item.image}" alt="${item.product_title}">
                  </div>
                  <div class="cart-item-details">
                    <div>
                      <span class="cart-item-title">${item.product_title ? item.product_title.toUpperCase() : ''}</span>
                      ${optionsString ? `<span class="cart-item-variant">${optionsString.toUpperCase()}</span>` : ''}
                    </div>
                    <div class="cart-item-price-row">
                      <span class="cart-item-price">${priceFormatted}</span>
                      <a href="#" class="cart-item-remove" data-action="remove">REMOVE</a>
                    </div>
                  </div>
                </div>
              `;
            });
            cartItemsContainer.innerHTML = itemsHtml;
            if (cartFooter) {
              cartFooter.style.display = 'block';
              const totalFormatted = (window.Shopify && window.Shopify.formatMoney) ? Shopify.formatMoney(cart.total_price) : `Rs. ${(cart.total_price/100).toLocaleString()}`;
              if (cartTotalPrice) cartTotalPrice.textContent = totalFormatted;

                // Update WhatsApp Link in Drawer
                const whatsappBtn = document.getElementById('cart-drawer-whatsapp-btn');
                if (whatsappBtn && window.Jivannti && window.Jivannti.settings && window.Jivannti.settings.enable_whatsapp_order) {
                  const settings = window.Jivannti.settings;
                  let itemList = '';
                  cart.items.forEach(item => {
                    let optionsString = '';
                    if (item.options_with_values && item.options_with_values.length > 0 && !(item.product_has_only_default_variant)) {
                      optionsString = item.options_with_values.map(o => `${o.name}: ${o.value}`).join(', ');
                    } else if (item.variant_title && item.variant_title !== 'Default Title') {
                      optionsString = item.variant_title;
                    }
                    itemList += `- ${item.product_title} ${optionsString ? `(${optionsString})` : ''} x ${item.quantity}\n`;
                  });
                  
                  let messageTemplate = settings.whatsapp_message_template || "Hi, I would like to order: \n\n[item_list] \n\nTotal: [total_price]";
                  let message = messageTemplate
                    .replace('[item_list]', itemList)
                    .replace('[total_price]', totalFormatted)
                    .replace('[cart_note]', cart.note || '');
                  
                  whatsappBtn.href = `https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent(message)}`;
                }
            }
          }
        }

        // Update all Page Buttons UI
        document.querySelectorAll('.quick-action-cart, .global-cart-btn, .sheet-add-btn').forEach(btn => {
          const form = btn.closest('form');
          const input = form ? form.querySelector('input[name="id"]') : null;
          if (input && itemsInCart.includes(input.value)) {
            btn.classList.add('in-cart');
            if (btn.classList.contains('sheet-add-btn')) {
              const textSpan = btn.querySelector('.btn-text');
              if (textSpan) textSpan.textContent = 'REMOVE FROM CART';
              else btn.textContent = 'REMOVE FROM CART';
            }
          } else {
            btn.classList.remove('in-cart');
            if (btn.classList.contains('sheet-add-btn')) {
              const textSpan = btn.querySelector('.btn-text');
              if (textSpan) textSpan.textContent = 'ADD TO CART';
              else btn.textContent = 'ADD TO CART';
            }
          }
        });

        // PDP Specific Feedback
        const pdpFeedbackMobile = document.getElementById('pdp-added-feedback');
        
        const firstVariantId = document.querySelector('.sheet-form input[name="id"]')?.value;
        const isProductInCart = firstVariantId && itemsInCart.includes(firstVariantId);

        if (pdpFeedbackMobile) pdpFeedbackMobile.style.display = isProductInCart ? 'flex' : 'none';
      })
      .catch(err => console.error('Error fetching cart:', err));
  };

  // --- Cart Drawer Interactions ---
  const cartToggle = document.getElementById('cart-toggle');
  
  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = '/cart';
    });
  }

  // Handle Removal within Drawer
  if (cartItemsContainer) {
    cartItemsContainer.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-action="remove"]');
      if (removeBtn) {
        e.preventDefault();
        const variantId = removeBtn.closest('.cart-item').getAttribute('data-variant-id');
        const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        
        fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 })
        }).then(() => refreshCartState());
      }
    });
  }

  // --- Image Loading Feedback ---
  const initImageLoaders = (scope = document) => {
    const handleImageLoad = (img) => {
      img.classList.add('img-loaded');
      const container = img.closest('.pdp-fixed-hero, .slider-bg-wrapper, .media-item, .sheet-media-item, .snap-section, .marquee-item');
      if (container) container.classList.add('container-loaded');
    };

    scope.querySelectorAll('img').forEach(img => {
      if (img.complete) {
        handleImageLoad(img);
      } else {
        img.addEventListener('load', () => handleImageLoad(img));
      }
    });
  };

  window.initImageLoaders = initImageLoaders;
  initImageLoaders();

  const updateHeaderTheme = () => {
    const mainHeader = document.getElementById('main-header');
    if (!mainHeader) return;

    // Ensure sections are captured (fallback for dynamic content)
    if (sections.length === 0) {
      sections = document.querySelectorAll('.snap-section');
    }

    // Use current scroll position instead of class to avoid race conditions with updateUI
    const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
    const isScrolled = currentScrollY > 50;

    // --- Dynamic Header Theme Switching ---
    // Find which section is currently "under" the header
    const currentSection = Array.from(sections).find(section => {
      const rect = section.getBoundingClientRect();
      // Check if section is overlapping the header area (top 100px)
      return rect.top <= 50 && rect.bottom > 50;
    });

    if (currentSection) {
      const sectionTheme = currentSection.getAttribute('data-header-theme') || 'light';
      // If scrolled OR menu is open, we force 'light' (Sand) text regardless of section setting
      // because the scrolled/menu background is dark/blurred.
      const isMenuOpen = body.classList.contains('menu-open');
      const activeTheme = (isScrolled || isMenuOpen) ? 'light' : sectionTheme;
      mainHeader.setAttribute('data-theme', activeTheme);
    } else {
      // Robust fallback for Home Page: if we are at the top, default to first section theme
      const isMenuOpen = body.classList.contains('menu-open');
      if (body.classList.contains('template-index') && sections.length > 0 && !isScrolled && !isMenuOpen) {
        const firstSectionTheme = sections[0].getAttribute('data-header-theme') || 'light';
        mainHeader.setAttribute('data-theme', firstSectionTheme);
      } else {
        // Fallback for pages without snap sections (like cart or static pages)
        mainHeader.setAttribute('data-theme', 'light');
      }
    }
  };

  // Set initial theme immediately to prevent flash
  updateHeaderTheme();

  // --- Optimized UI Update Loop ---
  let ticking = false;
  const updateUI = () => {
    // Update scroll position to latest
    scrollY = window.pageYOffset || document.documentElement.scrollTop;

    // Theme switching should run even if loader isn't done to prevent "light flash"
    updateHeaderTheme();

    // Collection Button Contrast Logic (Mobile Grid View Only)
    const toggleLayoutBtn = document.getElementById('toggle-layout-btn');
    const mainView = document.getElementById('collection-main-view');
    if (toggleLayoutBtn && mainView && mainView.classList.contains('view-mode-grid') && window.innerWidth <= 1024) {
      const rect = toggleLayoutBtn.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Offset by 20px to avoid hitting the dead-center grid gap
      const elements = document.elementsFromPoint(centerX - 20, centerY);
      const isOverProduct = elements.some(el => el.closest('.slider-item'));
      const isOverFooter = elements.some(el => el.closest('#main-footer') || el.closest('footer'));
      const isNearBottom = (window.innerHeight + scrollY) >= (document.documentElement.scrollHeight - 150);
      
      if (isOverProduct || isOverFooter || isNearBottom) {
        toggleLayoutBtn.classList.add('is-over-product');
      } else {
        toggleLayoutBtn.classList.remove('is-over-product');
      }
    }

    if (!isLoaderDone) { ticking = false; return; }

    const mainHeader = document.getElementById('main-header');
    if (mainHeader) {
      if (scrollY > 50) {
        mainHeader.classList.add('scrolled');
        body.classList.add('scrolled');
      } else {
        mainHeader.classList.remove('scrolled');
        body.classList.remove('scrolled');
      }
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateUI);
      ticking = true;
    }

    // --- PDP Full-Screen Blurred Interface Sync ---
    if (body.classList.contains('template-product')) {
      // Header state maintained as transparent to match slider view transition
      body.classList.add('sheet-docked'); 
    }
  };

  // --- CINEMATIC TRANSITIONS (SYSTEM RECODED FROM SCRATCH) ---
  
  // --- LOADER LOGIC ---
  try {
    const loader = document.getElementById('site-loader');
    const navEntries = performance.getEntriesByType("navigation");
    const isReload = navEntries.length > 0 && navEntries[0].type === 'reload';
    const hasLoadedInSession = sessionStorage.getItem('jivannti_first_load');
    const shouldShowLoader = isReload || !hasLoadedInSession;

    const hideLoader = (instantly = false) => {
      if (loader) {
        if (instantly) {
          loader.style.display = 'none';
          body.classList.remove('loader-active');
          body.classList.add('loader-done', 'loader-hidden');
          isLoaderDone = true;
          clearTimeout(failSafeTimeout);
          onScroll();
        } else {
          loader.style.opacity = 0;
          setTimeout(() => { 
            loader.style.display = 'none'; 
            body.classList.remove('loader-active');
            body.classList.add('loader-done', 'loader-hidden');
            isLoaderDone = true;
            clearTimeout(failSafeTimeout);
            onScroll(); 
          }, 1000);
        }
      }
    };

    // Sync cart immediately (non-blocking)
    refreshCartState().catch(() => {});

    if (!shouldShowLoader) {
      hideLoader(true);
    } else {
      sessionStorage.setItem('jivannti_first_load', 'true');
      // Guaranteed exit after 4.5s to allow the 3.6s fill animation to complete
      setTimeout(() => {
        hideLoader(false);
      }, 4500);
    }
  } catch (e) {
    console.error('Loader Logic Error:', e);
    // Emergency hide
    const loader = document.getElementById('site-loader');
    if (loader) loader.style.display = 'none';
    body.classList.remove('loader-active');
    body.classList.add('loader-done');
    isLoaderDone = true;
  }

  // --- Seamless PDP Transition (Grid Mode Specific) ---
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.product-full-link');
    if (!link || !mainView || !mainView.classList.contains('view-mode-grid')) return;

    const href = link.href;
    const item = link.closest('.slider-item');
    const img = item ? item.querySelector('img') : null;
    
    if (img) {
      e.preventDefault();
      
      // Grid Hero Expansion Animation
      const rect = img.getBoundingClientRect();
      const hero = document.createElement('div');
      hero.className = 'grid-to-pdp-hero';
      
      hero.style.top = rect.top + 'px';
      hero.style.left = rect.left + 'px';
      hero.style.width = rect.width + 'px';
      hero.style.height = rect.height + 'px';
      hero.style.backgroundImage = `url(${img.src})`;
      
      document.body.appendChild(hero);
      
      requestAnimationFrame(() => {
        body.classList.add('grid-leaving-for-pdp');
        hero.classList.add('active');
      });

      setTimeout(() => { window.location.href = href; }, 1000);
    }
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted || (performance.getEntriesByType("navigation").length > 0 && performance.getEntriesByType("navigation")[0].type === 'back_forward')) {
      body.classList.remove('leaving-for-pdp', 'grid-leaving-for-pdp', 'leaving-pdp', 'desktop-closing-pdp', 'menu-open');
    }
  });
  if (menuToggle && menuDrawer && menuStages) {
    const stageTriggers = document.querySelectorAll('.stage-trigger');
    const backButtons = document.querySelectorAll('.menu-back-btn');
    const activeTitle = document.getElementById('active-collection-title');

    menuToggle.addEventListener('click', () => {
      const isOpen = body.classList.contains('menu-open');
      if (isOpen) {
        body.classList.remove('menu-open');
        menuToggle.classList.remove('active');
        menuDrawer.classList.remove('active');
        document.querySelectorAll('.menu-stage').forEach(s => s.classList.remove('stage-active'));
        body.style.overflow = '';
        setTimeout(() => { 
          menuStages.style.transform = 'translateX(0vw)'; 
        }, 800);
      } else {
        body.classList.add('menu-open');
        menuToggle.classList.add('active');
        menuDrawer.classList.add('active');
        body.style.overflow = 'hidden';
        
        // Activate main stage with a small delay to match drawer opening
        setTimeout(() => {
          document.getElementById('stage-main').classList.add('stage-active');
        }, 100);
      }
      
      // Force UI update to recalculate header state (scrolled vs not) immediately after toggle
      ticking = false;
      updateUI();
    });

    stageTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = trigger.getAttribute('data-target');
        const targetStage = document.getElementById(targetId);
        
        if (targetStage) {
          const index = Array.from(targetStage.parentNode.children).indexOf(targetStage);
          menuStages.style.transform = `translateX(-${index * 100}vw)`;
          
          // Manage stage-active class for staggered animation
          document.querySelectorAll('.menu-stage').forEach(s => s.classList.remove('stage-active'));
          setTimeout(() => {
            targetStage.classList.add('stage-active');
          }, 400); // Wait for slide transition to start
        }
      });
    });

    backButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = btn.getAttribute('data-target');
        const targetStage = document.getElementById(targetId);
        if (targetStage) {
          const index = Array.from(targetStage.parentNode.children).indexOf(targetStage);
          menuStages.style.transform = `translateX(-${index * 100}vw)`;
          
          document.querySelectorAll('.menu-stage').forEach(s => s.classList.remove('stage-active'));
          setTimeout(() => {
            targetStage.classList.add('stage-active');
          }, 400);
        }
      });
    });
  }

  // --- Collection Page Logic (Slider & Grid Toggle) ---
  const toggleLayoutBtn = document.getElementById('toggle-layout-btn');
  const slider = document.getElementById('collection-slider');
  const prevBtn = document.getElementById('prev-btn');
  const nextBtn = document.getElementById('next-btn');

  if (toggleLayoutBtn && mainView) {
    toggleLayoutBtn.addEventListener('click', () => {
      const isSlider = mainView.classList.contains('view-mode-slider');
      if (isSlider) {
        mainView.classList.remove('view-mode-slider');
        mainView.classList.add('view-mode-grid');
        body.classList.add('grid-mode-active');
        toggleLayoutBtn.querySelector('.btn-label').textContent = 'SLIDER VIEW';
        sessionStorage.setItem('jivannti_collection_mode', 'grid');
      } else {
        mainView.classList.remove('view-mode-grid');
        mainView.classList.add('view-mode-slider');
        body.classList.remove('grid-mode-active');
        toggleLayoutBtn.querySelector('.btn-label').textContent = 'GRID VIEW';
        sessionStorage.setItem('jivannti_collection_mode', 'slider');
      }
    });
  }

  if (slider && prevBtn && nextBtn) {
    nextBtn.addEventListener('click', (e) => { e.preventDefault(); slider.scrollBy({ left: window.innerWidth, behavior: 'smooth' }); });
    prevBtn.addEventListener('click', (e) => { e.preventDefault(); slider.scrollBy({ left: -window.innerWidth, behavior: 'smooth' }); });
  }

  // --- PDP Back Button Logic ---
  // Handle PDP Gallery Navigation
  const galleryScrollContainer = document.querySelector('.marquee-track');
  const pdpPrevBtn = document.querySelector('.pdp-prev');
  const pdpNextBtn = document.querySelector('.pdp-next');

  if (galleryScrollContainer && pdpPrevBtn && pdpNextBtn) {
    pdpPrevBtn.addEventListener('click', () => {
      const scrollWidth = galleryScrollContainer.clientWidth;
      galleryScrollContainer.scrollBy({ left: -scrollWidth, behavior: 'smooth' });
    });

    pdpNextBtn.addEventListener('click', () => {
      const scrollWidth = galleryScrollContainer.clientWidth;
      galleryScrollContainer.scrollBy({ left: scrollWidth, behavior: 'smooth' });
    });

    // Optional: Hide/Show arrows based on scroll position and update dots
    galleryScrollContainer.addEventListener('scroll', () => {
      const scrollLeft = galleryScrollContainer.scrollLeft;
      const scrollWidth = galleryScrollContainer.clientWidth;
      const totalWidth = galleryScrollContainer.scrollWidth;
      
      const isAtStart = scrollLeft <= 10;
      const isAtEnd = scrollLeft + scrollWidth >= totalWidth - 10;
      
      if (pdpPrevBtn && pdpNextBtn) {
        pdpPrevBtn.style.opacity = isAtStart ? '0.3' : '1';
        pdpPrevBtn.style.pointerEvents = isAtStart ? 'none' : 'auto';
        pdpNextBtn.style.opacity = isAtEnd ? '0.3' : '1';
        pdpNextBtn.style.pointerEvents = isAtEnd ? 'none' : 'auto';
      }

      // --- Liquid Indicator Logic (Physical Mapping) ---
      const indicator = document.getElementById('gallery-indicator');
      const dots = document.querySelectorAll('.gallery-dot');
      
      if (indicator && dots.length > 1) {
        const maxScroll = totalWidth - scrollWidth;
        // Global scroll percentage (0 to 1)
        const scrollPercentage = Math.min(Math.max(scrollLeft / maxScroll, 0), 1);
        
        // Map scroll percentage to the physical space between first and last dot
        const firstDot = dots[0];
        const lastDot = dots[dots.length - 1];
        const travelDistance = lastDot.offsetLeft - firstDot.offsetLeft;
        
        // Calculate the base X position
        const targetX = firstDot.offsetLeft + (travelDistance * scrollPercentage);
        
        // Center the 24px indicator over the 6px dot
        const indicatorOffset = (24 - 6) / 2;
        indicator.style.transform = `translateY(-50%) translateX(${targetX - indicatorOffset}px)`;
        
        // --- Liquid Stretching Effect ---
        // Calculate partial progress between individual dots for the sine-wave stretch
        const stepCount = dots.length - 1;
        const individualStepProgress = (scrollPercentage * stepCount) % 1;
        const stretchAmount = Math.sin(individualStepProgress * Math.PI) * 12;
        indicator.style.width = `${24 + stretchAmount}px`;
      }
    });

    // Initial trigger to position indicator with a small delay for rendering
    setTimeout(() => {
      galleryScrollContainer.dispatchEvent(new Event('scroll'));
    }, 100);

    // Handle Dot Clicks
    document.addEventListener('click', (e) => {
      const dot = e.target.closest('.gallery-dot');
      if (dot && galleryScrollContainer) {
        const index = parseInt(dot.getAttribute('data-index'));
        const vhInPx = window.innerWidth;
        const itemWidth = vhInPx * 0.85;
        const gap = parseFloat(getComputedStyle(document.querySelector('.marquee-track')).gap) || 24;
        const step = itemWidth + gap;
        galleryScrollContainer.scrollTo({ left: index * step, behavior: 'smooth' });
      }
    });
  }

  // Handle PDP Back Button
  const pdpBackBtn = document.getElementById('pdp-back-btn-mobile');
  const pdpDesktopBackBtn = document.getElementById('pdp-back-btn-desktop');
  const pdpHeaderBackBtn = document.getElementById('pdp-back-btn-header');

  const handlePdpClose = (e) => {
    e.preventDefault();
    body.classList.add('leaving-pdp');
    
    // Desktop-specific: Add a class to slide the whole layout down
    if (window.innerWidth > 1024) {
      body.classList.add('desktop-closing-pdp');
    }

    setTimeout(() => {
      window.history.back();
    }, 1400); 
  };

  if (pdpBackBtn) pdpBackBtn.addEventListener('click', handlePdpClose);
  if (pdpDesktopBackBtn) pdpDesktopBackBtn.addEventListener('click', handlePdpClose);
  if (pdpHeaderBackBtn) pdpHeaderBackBtn.addEventListener('click', handlePdpClose);

  // Desktop Spiral Gallery Expansion Logic
  const spiralItems = document.querySelectorAll('.spiral-item');
  if (spiralItems.length > 0) {
    spiralItems.forEach(item => {
      item.addEventListener('click', () => {
        // Close others if any are open
        spiralItems.forEach(otherItem => {
          if (otherItem !== item) otherItem.classList.remove('expanded');
        });
        item.classList.toggle('expanded');
      });
    });
  }

// --- Toast Notification Helper ---
  const toastContainer = document.getElementById('toast-container');
  function showToast(message) {
    if (!toastContainer) return;
    
    // Only show toast in Slider View (Collection page modes)
    const isSlider = mainView && mainView.classList.contains('view-mode-slider');
    if (!isSlider) return;

    const toast = document.createElement('div');
    toast.className = 'toast-message';
    toast.textContent = message;
    toastContainer.appendChild(toast);
    setTimeout(() => { toast.remove(); }, 3000);
  }

  // --- AJAX Cart Logic ---
  const handleCartToggle = (form) => {
    const formData = new FormData(form);
    const pId = formData.get('id');
    const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const btn = form.querySelector('button[type="submit"]');

    if (btn) btn.classList.add('is-loading');
    
    const startTime = Date.now();
    const minWait = 800; // ms to ensure loader is visible and feels "mechanical"

    const finishLoading = () => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minWait - elapsed);
      setTimeout(() => {
        if (btn) btn.classList.remove('is-loading');
      }, remaining);
    };

    if (itemsInCart.includes(pId)) {
      fetch(rootUrl + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: pId, quantity: 0 }) })
      .then(() => { 
        showToast('ITEM REMOVED FROM CART'); 
        return (window.refreshCartState ? window.refreshCartState(true) : refreshCartState()); 
      })
      .finally(finishLoading);
    } else {
      fetch(rootUrl + 'cart/add.js', { method: 'POST', body: formData })
      .then(() => { 
        showToast('ITEM ADDED TO CART'); 
        return (window.refreshCartState ? window.refreshCartState(true) : refreshCartState()); 
      })
      .finally(finishLoading);
    }
  };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form');
    if (form && form.action && form.action.includes('/cart/add')) { 
      e.preventDefault(); 
      handleCartToggle(form); 
    }
  });

  // --- Slider Observer for Global Buttons ---
  const globalCartIdInput = document.getElementById('global-cart-id');
  if (slider && globalCartIdInput) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const productId = entry.target.getAttribute('data-product-id');
          const variantId = entry.target.getAttribute('data-variant-id');
          if (productId && variantId) {
            globalCartIdInput.value = variantId;

            const globalCartBtn = document.querySelector('.global-cart-btn');
            if(globalCartBtn) {
              if(itemsInCart.includes(variantId.toString())) globalCartBtn.classList.add('in-cart');
              else globalCartBtn.classList.remove('in-cart');
            }
          }
        }
      });
    }, { root: slider, threshold: 0.5 });
    document.querySelectorAll('.slider-item').forEach(item => observer.observe(item));
  }

  // --- Product Variant Selection ---
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.sheet-value-chip, .desktop-value-chip');
    if (chip) {
      const parent = chip.closest('.product-option-values');
      const form = chip.closest('form');
      const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      
      // Update UI
      parent.querySelectorAll('button').forEach(btn => btn.classList.remove('active'));
      chip.classList.add('active');

      // Map selection to variant ID
      const variants = JSON.parse(document.getElementById('product-variants-json').textContent);
      const selectedValues = Array.from(form.querySelectorAll('.product-option-values .active')).map(btn => btn.getAttribute('data-value'));
      
      const selectedVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === selectedValues[index]);
      });

      if (selectedVariant && variantIdInput) {
        variantIdInput.value = selectedVariant.id;
        
        // Update WhatsApp link if it exists
        const whatsappBtn = form.querySelector('.whatsapp-order-btn');
        if (whatsappBtn) {
          const template = whatsappBtn.getAttribute('data-template') || "Hi, I am interested in [product_name] ([variant_name]). \nPrice: [product_price] \nLink: [product_url]";
          const baseUrl = whatsappBtn.href.split('?')[0];
          const productName = whatsappBtn.getAttribute('data-product-name') || '';
          
          const urlObj = new URL(window.location.href);
          urlObj.searchParams.set('variant', selectedVariant.id);
          const productUrl = urlObj.toString();
          
          const priceFormatted = (window.Shopify && window.Shopify.formatMoney) 
            ? Shopify.formatMoney(selectedVariant.price) 
            : `Rs. ${(selectedVariant.price/100).toLocaleString()}`;
          
          let msg = template;
          if (msg.includes('[variant_name]')) {
            msg = msg.replace('[variant_name]', '[variant_options]');
          }
          if (!msg.includes('[variant_options]')) {
            msg = msg.replace('[product_name]', '[product_name] ([variant_options])');
          }
          
          msg = msg.replace('[product_name]', productName);
          
          if (selectedVariant.title && selectedVariant.title !== 'Default Title') {
            const optionNames = JSON.parse(document.getElementById('product-options-json').textContent || '[]');
            const optionsList = optionNames.map((name, index) => {
              const val = selectedVariant.options[index];
              return `${name}: ${val}`;
            }).join(', ');
            
            msg = msg.replace('[variant_options]', optionsList);
          } else {
            msg = msg.replace('([variant_options])', '')
                     .replace('[variant_options]', '');
          }
          
          msg = msg
            .replace('[product_price]', priceFormatted)
            .replace('[product_url]', productUrl);
          
          // Clean up double spaces
          msg = msg.replace(/  +/g, ' ').trim();
            
          whatsappBtn.href = `${baseUrl}?text=${encodeURIComponent(msg)}`;
        }
      }
    }
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { vh = window.innerHeight; onScroll(); }, { passive: true });

  // --- Real-time Cross-tab Sync ---
  const syncChannel = window.BroadcastChannel ? new BroadcastChannel('jivannti_sync') : null;

  if (syncChannel) {
    syncChannel.onmessage = (event) => {
      if (event.data.type === 'cart_updated') {
        refreshCartState();
        if (body.classList.contains('template-cart')) window.location.reload();
      }
    };
  }

  // Modify refreshCartState to broadcast (when it's a mutation)
  const originalRefreshCartState = refreshCartState;
  window.refreshCartState = function(isMutation = false) {
    const p = originalRefreshCartState();
    if (isMutation && syncChannel) {
      p.then(() => syncChannel.postMessage({ type: 'cart_updated' }));
    }
    return p;
  };

  // --- Shopify Theme Editor Reactivity ---
  document.addEventListener('shopify:section:load', () => {
    sections = document.querySelectorAll('.snap-section');
    updateHeaderTheme();
    if (typeof initImageLoaders === 'function') initImageLoaders();
  });

  document.addEventListener('shopify:section:unload', () => {
    sections = document.querySelectorAll('.snap-section');
  });

  // --- Custom DOM Scrollbar Logic ---
  const scrollTrack = document.getElementById('custom-scrollbar-container');
  const scrollThumb = document.getElementById('custom-scrollbar-thumb');
  
  if (scrollTrack && scrollThumb) {
    let isDraggingScrollbar = false;
    let startY;
    let startScrollTop;

    const updateCustomScrollbar = () => {
      if (window.innerWidth <= 1024) return;
      
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollHeight <= clientHeight) {
        scrollThumb.style.display = 'none';
        return;
      } else {
        scrollThumb.style.display = 'block';
      }
      
      const scrollRatio = clientHeight / scrollHeight;
      const thumbHeight = Math.max(scrollRatio * clientHeight, 40); // min 40px height
      
      const maxScrollTop = scrollHeight - clientHeight;
      const maxThumbTop = clientHeight - thumbHeight;
      
      const thumbTop = (scrollTop / maxScrollTop) * maxThumbTop;
      
      scrollThumb.style.height = `${thumbHeight}px`;
      scrollThumb.style.transform = `translateY(${thumbTop}px)`;
    };

    window.addEventListener('scroll', () => {
      if (!isDraggingScrollbar) {
        requestAnimationFrame(updateCustomScrollbar);
      }
    });
    window.addEventListener('resize', updateCustomScrollbar);
    
    // Initial calls
    updateCustomScrollbar();
    setTimeout(updateCustomScrollbar, 500);
    setTimeout(updateCustomScrollbar, 1500);

    // Dragging logic
    scrollThumb.addEventListener('mousedown', (e) => {
      isDraggingScrollbar = true;
      startY = e.clientY;
      startScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      scrollThumb.classList.add('is-dragging');
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDraggingScrollbar) return;
      
      const deltaY = e.clientY - startY;
      
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const maxScrollTop = scrollHeight - clientHeight;
      
      const scrollRatio = clientHeight / scrollHeight;
      const thumbHeight = Math.max(scrollRatio * clientHeight, 40);
      const maxThumbTop = clientHeight - thumbHeight;
      
      const scrollDelta = (deltaY / maxThumbTop) * maxScrollTop;
      
      window.scrollTo(0, startScrollTop + scrollDelta);
      updateCustomScrollbar();
    });

    document.addEventListener('mouseup', () => {
      if (isDraggingScrollbar) {
        isDraggingScrollbar = false;
        scrollThumb.classList.remove('is-dragging');
        document.body.style.userSelect = '';
      }
    });
  }
});